module.exports = __webpack_public_path__ + "static/media/Logo-nepali.7c74655c.png";